import React from 'react';
import { Link } from 'react-router-dom';

/* Единый источник правды для списка документов.
   Пути тянутся из .env (с фолбэками). */
const LEGAL_BASE = 'https://mailora.ru';
const legalUrl = (p) => LEGAL_BASE + p;

// export const LEGAL_DOCS = [
//   { label: 'Публичная оферта',            path: legalUrl(process.env.REACT_APP_LEGAL_TERMS_PATH        || '/terms') },
//   { label: 'Политика конфиденциальности', path: legalUrl(process.env.REACT_APP_LEGAL_PRIVACY_PATH      || '/privacy') },
//   { label: 'Политика cookie',             path: legalUrl(process.env.REACT_APP_LEGAL_COOKIES_PATH      || '/cookies') },
//   { label: 'Анти-спам политика',          path: legalUrl(process.env.REACT_APP_LEGAL_ANTI_SPAM_PATH    || '/anti-spam') },
// //   { label: 'Условия подписки',            path: legalUrl(process.env.REACT_APP_LEGAL_SUBSCRIPTION_PATH || '/subscription') },
// ];
export const LEGAL_DOCS = [
  { code: 'terms',    label: 'Публичная оферта',             path: '/terms',     version: '2026-09-16' },
  { code: 'privacy',  label: 'Политика конфиденциальности',  path: '/privacy',   version: '2026-09-16' },
  { code: 'cookie',   label: 'Политика cookie',              path: '/cookies',   version: '2026-09-16' },
  { code: 'antispam', label: 'Анти-спам политика',           path: '/anti-spam', version: '2026-09-16' },
];

export default function LegalLayout({ title, updated, children }) {
  return (
    <div className="min-h-screen bg-gray-50 text-gray-900 flex flex-col">
      {/* ---------- header ---------- */}
      <header className="sticky top-0 z-40 bg-white border-b border-gray-200">
        <div className="max-w-6xl mx-auto px-4 h-16 flex items-center justify-between">
          <Link to="/" className="flex items-center gap-2 text-xl font-bold text-blue-600">
            <span className="w-2 h-2 rounded-full bg-blue-600 inline-block" />
            MAILORA
          </Link>
          <Link
            to="/"
            className="text-sm text-gray-600 hover:text-blue-600 transition"
          >
            ← На главную
          </Link>
        </div>
      </header>

      {/* ---------- content ---------- */}
      <main className="flex-1">
        <div className="max-w-3xl mx-auto px-4 py-12">
          <h1 className="text-3xl md:text-4xl font-bold mb-2">{title}</h1>
          {updated && (
            <p className="text-sm text-gray-500 mb-8">Редакция от {updated}</p>
          )}

          {/* Типографика для юридического текста */}
          <article className="legal-prose">
            {children}
          </article>
        </div>
      </main>

      {/* ---------- footer ---------- */}
      <footer className="bg-white border-t border-gray-200 py-10">
        <div className="max-w-6xl mx-auto px-4">
            <nav className="flex flex-wrap gap-x-5 gap-y-2 text-sm text-gray-600">
            {LEGAL_DOCS.map((doc) => (
                <a
                key={doc.path}
                href={doc.path}
                className="hover:text-blue-600 transition"
                >
                {doc.label}
                </a>
            ))}
            </nav>
          <div className="mt-6 text-[13px] text-gray-500">
            © {new Date().getFullYear()} Mailora. Все права защищены.
          </div>
        </div>
      </footer>

      {/* CSS-типографика для текста документов — один раз на все страницы */}
      <style>{`
        .legal-prose h2 {
          font-size: 20px;
          font-weight: 600;
          margin: 32px 0 10px;
        }
        .legal-prose h3 {
          font-size: 16px;
          font-weight: 600;
          margin: 24px 0 8px;
        }
        .legal-prose p, .legal-prose li {
          font-size: 15px;
          color: #1f2937;
          line-height: 1.7;
        }
        .legal-prose p { margin: 0 0 14px; }
        .legal-prose ul, .legal-prose ol {
          padding-left: 22px;
          margin: 0 0 14px;
        }
        .legal-prose li { margin-bottom: 6px; }
        .legal-prose a { color: #2563eb; }
        .legal-prose strong { font-weight: 600; }
      `}</style>
    </div>
  );
}